import { defineComponent as a, openBlock as r, createBlock as t, normalizeProps as o, guardReactiveProps as n, withCtx as p, renderSlot as c, createElementVNode as s } from "vue";
import d from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ s("path", {
  "fill-rule": "evenodd",
  d: "M5.999 5v.007a1 1 0 01-1.435.9l-2.003-.966a1 1 0 01-.03-1.786l2.004-1.049A1 1 0 016 2.992V3h.009a7.005 7.005 0 016.888 5.75 1 1 0 01-1.705.924.837.837 0 01-.246-.462A5.004 5.004 0 006.008 5h-.01zm9.268 7.694l-1.812.784.94 1.525 5.138-2.203-.933-1.53-3.333 1.424zm-3.269-.778l1.586-.678 2.856-1.239-1.452-.615-.014-.126c-.033-.31-.08-.762-.143-1.065a10.38 10.38 0 00-.334-1.19l4.76 2.019c.122.034.237.091.339.169.155.11.275.264.346.439l1.899 3.114a1 1 0 01-.46 1.44l-1.39.596V18a1 1 0 01-.606.92l-6.934 2.967a1 1 0 01-.458.11 1 1 0 01-.457-.11L4.602 18.92a1 1 0 01-.607-.92v-3.22l-1.39-.595a1 1 0 01-.46-1.44l1.95-3.198a1 1 0 01.512-.485l3.286-1.386c.143.106.404.314.675.765.243.402.313.717.355.903l.014.062-1.394.588 4.455 1.923zm5.993 5.424v-1.703l-3.6 1.544a1 1 0 01-1.246-.395l-.149-.241v2.933l4.995-2.138zm-7-.795v2.933L5.994 17.34v-1.703l3.601 1.544a1 1 0 001.245-.395l.15-.241zM4.453 12.8l.942-1.545 5.135 2.223-.94 1.525L4.455 12.8z",
  "clip-rule": "evenodd"
}, null, -1), f = /* @__PURE__ */ a({
  name: "Returns",
  __name: "returns",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (l, u) => (r(), t(d, o(n(e.props)), {
      default: p(() => [c(l.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
